import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
import { lg, md, wide, xl, xl2, xwide } from '../common';
import { attachVisibilityBasedToggler } from '../lib/autoplayVisibilityBasedToggler';

export function initBlockCredits(parent) {
  if (!parent) return;

  const swiper = parent.querySelector('.swiper');

  const swiperHandler = new Swiper(swiper, {
    modules: [Autoplay],
    loop: true,
    centeredSlides: true,
    slidesPerView: 'auto',
    spaceBetween: 10,
    autoplay: { delay: 3000 },
    breakpoints: {
      [md]: { spaceBetween: 12 },
      [xl]: { spaceBetween: 16 },
      [xl2]: { spaceBetween: 20 },
      [wide]: { spaceBetween: 24 },
      [xwide]: { spaceBetween: 32 },
    },
  });

  attachVisibilityBasedToggler(swiper, swiperHandler);
}

export function initAllBlockCredits() {
  const blocks = document.querySelectorAll('.js-block-credits');
  blocks.forEach((block) => initBlockCredits(block));
}
